// import styles from './ToastCard.module.scss';

import * as React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import ToastStatusEnum from "../../../../constants/ToastStatusEnum";
import ToastsAction from "../../../../stores/toasts/ToastsAction";

const mapStateToProps = (state, ownProps) => ({});

class ToastCard extends React.Component {
  buttonColorMap = {
    [ToastStatusEnum.Error]: "alert-danger",
    [ToastStatusEnum.Warning]: "alert-warning",
    [ToastStatusEnum.Success]: "alert-success",
    [ToastStatusEnum.Info]: "alert-info"
  };

  titleKeyMap = {
    [ToastStatusEnum.Error]: "toast_error",
    [ToastStatusEnum.Warning]: "toast_warning",
    [ToastStatusEnum.Success]: "toast_success",
    [ToastStatusEnum.Info]: "toast_info"
  };

  render() {
    const { item, t } = this.props;
    return (
      //Alert Classes --> Success = alert-success | Error = alert-danger | Info= alert-info | Warning = alert-warning
      <div className={"toster " + this.buttonColorMap[item.type]}>
        <div className="content">
          <h3 className="head fs18 text-uppercase">
            {t(this.titleKeyMap[item.type] || "toast_info")}!
          </h3>
          <p className="description fs14 mb0">
            {t(item.messageKey || "requestFailed")}
          </p>
        </div>
        <div className="tost-close">
          <em
            className="fa fa-times cursor-pointer"
            role="button"
            aria-label={t("close")}
            onClick={this._onClickRemoveNotification}
          />
        </div>
      </div>
    );
  }

  _onClickRemoveNotification = (event, data) => {
    this.props.dispatch(ToastsAction.removeById(this.props.item.id));
  };
}

export { ToastCard as Unconnected };
export default withTranslation()(connect(mapStateToProps)(ToastCard));
